export default __webpack_public_path__ + "static/media/formations.01d756b2.jpg";